import {VideoItemPanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-video-options/poster-editing-video-options.types';
import {useEffect} from 'react';
import {BorderType} from '@PosterWhiteboard/classes/item-border.class';
import {useGetKeyFromShadowOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromShadowOfActiveItem';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';
import {ShadowOrGlowType} from '@postermywall/fabricjs-2';

export function useIsOpenedVideoPanelValid(currentlyOpenedSubPanel: VideoItemPanels, setCurrentlyOpenedSubPanel: (newVal: VideoItemPanels) => void): void {
  const shadowOrGlowType = useGetKeyFromShadowOfActiveItem('shadowOrGlowType');
  const solidBorderType = useGetKeyFromBorderOfActiveItem('solidBorderType');
  const tint = useGetKeyFromEffectsActiveItem('tint');
  const multiply = useGetKeyFromEffectsActiveItem('multiply');

  useEffect((): void => {
    if (shadowOrGlowType !== ShadowOrGlowType.CUSTOM_SHADOW && currentlyOpenedSubPanel === VideoItemPanels.SHADOW) {
      setCurrentlyOpenedSubPanel(VideoItemPanels.NONE);
    }
  }, [shadowOrGlowType]);

  useEffect((): void => {
    if (!(shadowOrGlowType === ShadowOrGlowType.LIGHT_GLOW || shadowOrGlowType === ShadowOrGlowType.STRONG_GLOW) && currentlyOpenedSubPanel === VideoItemPanels.GLOW) {
      setCurrentlyOpenedSubPanel(VideoItemPanels.NONE);
    }
  }, [shadowOrGlowType]);

  useEffect((): void => {
    if (solidBorderType === BorderType.NONE && currentlyOpenedSubPanel === VideoItemPanels.BORDER) {
      setCurrentlyOpenedSubPanel(VideoItemPanels.NONE);
    }
  }, [solidBorderType]);

  useEffect((): void => {
    if (!tint && currentlyOpenedSubPanel === VideoItemPanels.TINT) {
      setCurrentlyOpenedSubPanel(VideoItemPanels.NONE);
    }
  }, [tint]);

  useEffect((): void => {
    if (!multiply && currentlyOpenedSubPanel === VideoItemPanels.MULTIPLY) {
      setCurrentlyOpenedSubPanel(VideoItemPanels.NONE);
    }
  }, [multiply]);
}
